import { EventTypeEnum } from '../../../../../../../common/dist/angular/enums/event-type.enum';
import { Injectable } from '@angular/core';
import { TimelineEventModel } from './timeline-event.model';
import {
  CalculationRunEventPayload,
} from '../../../../../../../server/dist/angular/server/src/microservice/event-payloads/calculation-run.event-payload';
import { enCA, frCA } from 'date-fns/locale';
import { formatDistance } from 'date-fns';
import { TranslateService } from '@ngx-translate/core';
import { EventIndexModel } from '../../../../../../../common/src/index-models/event.index-model';

@Injectable()
export class TimelineEventModelMapper {
  constructor(private readonly translateService: TranslateService) {
  }

  public map(event: EventIndexModel<any>): TimelineEventModel {
    const timelineEvent = new TimelineEventModel();
    timelineEvent.id = event.id;
    timelineEvent.organizationId = event.organizationId;
    timelineEvent.eventType = event.eventType;
    timelineEvent.createdAt = event.createdAt;
    timelineEvent.userName = this.getNameText(event);
    timelineEvent.payload = event.payload;
    this.fillEventTexts(event, timelineEvent);

    return timelineEvent;
  }

  public getNameText(event: EventIndexModel<any>): string {
    return event.userFirstName + ' ' + event.userLastName;
  }

  public fillEventTexts(event: EventIndexModel<any>, timelineEvent: TimelineEventModel): void {
    switch (event.eventType) {
      case EventTypeEnum.CalculationRun:
        event = event as EventIndexModel<CalculationRunEventPayload>;
        timelineEvent.titleText = event.payload?.title ?? 'Calcul sans nom';
        timelineEvent.eventText = 'Le calcul a été effectué';
        timelineEvent.lastModifiedText = this.getLastModifiedText(event.createdAt);
    }
  }

  public getLastModifiedText(eventTime: Date): string {
    if (eventTime === undefined) {
      return 'En cours de chargement...'; // todo: translation
    }

    let locale = enCA;

    if (this.translateService.currentLang.startsWith('fr')) {
      locale = frCA;
    }

    return formatDistance(eventTime, Date.now(), {
      locale,
      addSuffix: true,
    });
  }
}
